import { styled } from '@linaria/react'
import React, { type FC } from 'react'
import { colors } from '../styles/colors'
import { Typography } from './Typography'

interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  description?: string
  disabled?: boolean
  className?: string
}

export const Switch: FC<SwitchProps> = ({
  checked,
  onChange,
  label,
  description,
  disabled = false,
  className,
}) => {
  return (
    <Container className={className}>
      <SwitchElement
        type="button"
        checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
      >
        <SwitchTrack checked={checked} disabled={disabled}>
          <SwitchThumb checked={checked} disabled={disabled} />
        </SwitchTrack>
      </SwitchElement>

      <TextContainer>
        <Typography fontSize={14} fontWeight={400}>
          {label}
        </Typography>

        {description && (
          <Typography fontSize={10} fontWeight={400}>
            {description}
          </Typography>
        )}
      </TextContainer>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
`

const SwitchElement = styled.button<{ checked: boolean; disabled: boolean }>`
  background: transparent;
  border: none;
  padding: 0;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  width: 34px;
  height: 22px;
  flex-shrink: 0;

  &:focus {
    outline: none;
  }
`

const SwitchTrack = styled.div<{ checked: boolean; disabled: boolean }>`
  position: relative;
  width: 34px;
  height: 22px;
  background: ${props => (props.checked ? colors.secondary : colors.grey300)};
  border-radius: 22px;
  transition: background-color 0.2s ease;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
`

const SwitchThumb = styled.div<{ checked: boolean; disabled: boolean }>`
  position: absolute;
  top: 2px;
  left: ${props => (props.checked ? '14px' : '2px')};
  width: 18px;
  height: 18px;
  background: ${colors.white};
  border-radius: 50%;
  transition: left 0.2s ease;
  box-shadow: 0px 1px 3px ${colors.shadowLight};
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`
